import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { UiTableContainer } from './CountyCmsSchoolsTable.style';
import { TABLE_HEAD_CELLS } from './CountyCmsSchoolsTable.constant';

/**
 * 學習報告 - 學校使用紀錄表格
 */
export const CountyCmsSchoolsTable = ({
  unit,
  schools,
  isLoading
}) => {
  const tableHeadCells = TABLE_HEAD_CELLS[unit];
  return (
    <UiTableContainer component={Paper} unit={unit}>
      <Table>
        <TableHead>
          <TableRow>
            {tableHeadCells.map(cell => {
              return (
                <TableCell key={cell.name} align="left" scope="column">
                  {cell.name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={tableHeadCells.length}
                style={{ textAlign: 'center' }}
              >
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : (
            schools.map(school => {
              return (
                <TableRow key={uuidV4()}>
                  {Object.entries(school).map(([key, value]) => (
                    <TableCell key={uuidV4()}>
                      <Typography>{value || '-'}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </UiTableContainer>
  );
};

CountyCmsSchoolsTable.propTypes = {
  unit: PropTypes.string,
  schools: PropTypes.array,
  isLoading: PropTypes.bool
};
